import type React from 'react';

import styles from './SplitValueElement.module.scss';

export interface SplitValueElementProps {
    children?: (React.ReactNode | number | string)[];
    variant?: 'default' | 'highlight';
}

function SplitValueElement({ children = [], variant = 'default' }: SplitValueElementProps) {
    return (
        <div className={styles.splitvalueelement} data-variant={variant}>
            {children.map((child, index) => (
                // The slot position is the identity here: the first value sits right, the rest
                // left, and the list is never reordered.
                <span data-dir={index === 0 ? 'right' : 'left'} data-type="splitvalue" key={index}>
                    {child}
                </span>
            ))}
        </div>
    );
}

export default SplitValueElement;
export { SplitValueElement };
